export default (urlParameters) => {
  return {
    ads_allowed: false,
    complete_report_map: false,
    customize_map_button_default: false,
    customize_map_button: false,
    detail_panel: false,
    favorites_button: false,
    feature_version: 1.0,
    global_user_profile_manager: false,
    map_favoriting: false,
    map_name_block: false,
    map_selector_button: false,
    nc_wind_toggle_allowed: false,
    pinned_map_bar: false,
    platform: 'web',
    proforecast_allowed: false,
    promo_modal_allowed: false,
    show_complete_report_sync_control: false,
    show_widgets: false,
    spot_distance_grouping: false,
    regional_navigation: false,
    storm_center: false,
    storm_track: false,
    ui_default_theme: 'light',
    web_view: false
  }
}